import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const CONTEXTUAL_VIDEO_REPORT_ID = `contextual${VIDEO_CAMPAIGN_SUFFIX}`;
